import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

const TotalProductCategory = ({ categoryName }) => {
  if (!categoryName) {
    return null;
  }

  return (
    <div className="total-product-category">
      {' '}in <h1>{ categoryName }</h1>
    </div>
  );
};

export default class TotalProductNumber extends PureComponent {
  static propTypes = {
    itemsCount: PropTypes.number.isRequired,
    categoryName: PropTypes.string,
  };

  render() {
    const { itemsCount, categoryName } = this.props;

    return (
      <div className="total-product-number">
        <span>{`${itemsCount} ${itemsCount > 1 ? 'products' : 'product'}`}</span>
        <TotalProductCategory categoryName={categoryName} />
      </div>
    );
  }
}
